import React, { useState, useEffect } from "react";
import { Typography, Stack, Divider, Grid, Input } from "@mui/joy";
import { MoreHorizRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import GenericTable from "../GenericTable/GenericTable";
import WarningWithRedirect from "./WarningWithRedirect";

export default function SelectionTable({
  label,
  onChange,
  locations = [],
  selectedLocations = [],
}) {
  const { t } = useTranslation();

  const columns = [
    { field: "name", headerName: t("name") },
    { field: "question", headerName: t("question") },
    { field: "answer", headerName: t("correctAnswer") },
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocationIds, setSelectedLocationIds] = useState([]);

  useEffect(() => {
    setSelectedLocationIds(selectedLocations.map((location) => location._id));
  }, [selectedLocations]);

  const availableLocations = locations.filter(
    (location) => !selectedLocationIds.includes(location._id)
  );

  const locationsInHunt = locations.filter((location) =>
    selectedLocationIds.includes(location._id)
  );

  function handleSearchChange(e) {
    setSearchTerm(e.target.value);
  }

  function handleSelect(locationId) {
    const newSelectedLocationIds = selectedLocationIds.includes(locationId)
      ? selectedLocationIds.filter((id) => id !== locationId)
      : [...selectedLocationIds, locationId];

    setSelectedLocationIds(newSelectedLocationIds);
    onChange(newSelectedLocationIds);
  }

  return (
    <React.Fragment>
      <Stack
        sx={{
          width: "100%",
        }}
      >
        <Typography level="h4">{label}</Typography>
        <Divider>
          <MoreHorizRounded />
        </Divider>
        <Input
          placeholder={t("searchLocations")}
          value={searchTerm}
          onChange={handleSearchChange}
          fullWidth
          sx={{
            mb: 2,
          }}
        />
        <Grid container spacing={2} rowSpacing={8}>
          <Grid item xs={12} md={6}>
            {availableLocations.length ? (
              <GenericTable
                title={t("availableLocations")}
                columns={columns}
                rows={availableLocations.filter((location) =>
                  location.name.toLowerCase().includes(searchTerm.toLowerCase())
                )}
                onSelect={handleSelect}
              />
            ) : (
              <WarningWithRedirect
                message={t("createANewLocationHere")}
                redirectLink="/locations/myLocations/edit"
              />
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            {locationsInHunt.length ? (
              <GenericTable
                title={t("locationsInHunt")}
                columns={columns}
                rows={locationsInHunt}
                onSelect={handleSelect}
              />
            ) : (
              <WarningWithRedirect message={t("clickOnALocationToAdd")} />
            )}
          </Grid>
        </Grid>
      </Stack>
    </React.Fragment>
  );
}
